import * as React from 'react';
import { AnyObject } from 'final-form';
import { IRootState } from 'src/reducers';
import { connect } from 'react-redux';
import CardContainer from '../common/CardContainer';
import { Card } from '@blueprintjs/core';

interface IFormDocComponentState {
    formState: AnyObject;
}

class FormDocComponent extends React.Component<IFormDocComponentState> {
    public render() {
        return (
            <CardContainer>
                <Card elevation={1} className="lh-form-panel">
                    Name is{' '}
                    <span style={{ background: 'white', padding: '.2rem .5rem' }}>
                        {(this.props.formState && this.props.formState.values.name) || '[name]'}
                    </span>
                    <br />
                    City is{' '}
                    <span style={{ background: 'white', padding: '.2rem .5rem' }}>
                        {(this.props.formState && this.props.formState.values.city) || '[city]'}
                    </span>
                    <br />
                </Card>
            </CardContainer>
        );
    }
}

function mapStateToProps(state: IRootState) {
    return {
        formState: state.navigation.formState,
    };
}

export default connect(mapStateToProps, undefined)(FormDocComponent);



// WEBPACK FOOTER //
// ./src/components/FormPoc/Document.tsx